module.exports = __webpack_public_path__ + "static/media/Hemmingway.8811fd2d.png";